export enum BEWeekdayEnum {
  All = 'All',
  First = 'First',
  Second = 'Second',
  Third = 'Third',
  Fourth = 'Fourth',
  Fifth = 'Fifth',
  Last = 'Last',
}
